import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import SearchIcon from '@offerzen/zenicon/SearchIcon'
import { colors } from '../../themes'
import AccessibleIcon from '../AccessibleIcon'
import styles, { wrapperTheme } from './styles'

const SearchInput = ({ meta, input, theme, className, onChange, ...props }) => {
  const value = input.value || props.value
  const handler = input.onChange || onChange

  return (
    <div className={cx(styles.wrapper, className, wrapperTheme(theme))}>
      <input
        className={styles.input}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...input}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        type="text"
        value={value}
        onChange={handler}
      />
      <div className={styles.icon}>
        <AccessibleIcon icon={SearchIcon} size={20} color={colors.geyser} />
      </div>
    </div>
  )
}

SearchInput.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
}

SearchInput.defaultProps = {
  meta: {},
  input: {},
  theme: 'primary',
  value: '',
  tabIndex: '0',
}

export default SearchInput
